import { useEffect } from 'react';
import { Box } from '@mui/material';
import { Subsections } from '../SessionSignOffV4.constant';
import { DiagnosisSection } from './DiagnosisSection';
import { BillingRequirementsSection } from './BillingRequirementsSection';
import { ProfileInfoRole } from '../../../../../components/v2/ProfileInfo';

export const CptCodesSection = ({
  selectedSubSection,
  setSelectedSubSection,
  appointment,
  openGiggle,
  role,
  handleOpenReasoning,
}) => {
  useEffect(() => {
    if (!selectedSubSection) {
      if (
        role === ProfileInfoRole.THERAPIST ||
        role === ProfileInfoRole.NURSE_PRACTITIONER ||
        role === ProfileInfoRole.PHYSICIAN
      ) {
        setSelectedSubSection(Subsections.REVIEW_DIAGNOSIS);
      } else {
        setSelectedSubSection(Subsections.REVIEW_CPT_CODES);
      }
    }
  }, [selectedSubSection, setSelectedSubSection]);

  const renderSubsectionContent = () => {
    switch (selectedSubSection) {
      case Subsections.REVIEW_DIAGNOSIS:
        return <DiagnosisSection appointment={appointment} handleOpenReasoning={handleOpenReasoning} />;
      case Subsections.REVIEW_CPT_CODES:
        return <BillingRequirementsSection appointment={appointment} openGiggle={openGiggle} />;
      default:
        return <div>Select a subsection</div>;
    }
  };

  return <Box padding="16px">{renderSubsectionContent()}</Box>;
};
